<template>
  <div class="animated fadeIn">
    <div>
      <component-header
        :title="`${orgoName} - Wallet Statement`"
        @reload-data="getPartnerWalletListData"
        :isLoading="isloading"
        :hasCreate="false"
        :hasback="true"
        @back-press="goToViewPage"
        :hasSearch="false"
      />
      <div>
        <b-row class="mt-1 mb-1">
          <b-col md="6">
            <b-row>
              <b-col md="6">
                <b-row>
                  <b-col class="wallet-font"
                    ><b> Wallet Balence : </b>
                    <strong
                      :class="`ml-1 ${
                        walletBalence < 0 ? 'text-danger' : 'text-success'
                      }`"
                    >
                      ₹ {{ walletBalence ? walletBalence[0].toFixed(2) : "" }}
                    </strong>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row>
              <b-col md="5">
                <b-input id="start-date" type="date" v-model="walletStartDate"></b-input>
              </b-col>
              <b-col md="5">
                <b-input id="end-date" type="date" v-model="walletEndDate"></b-input>
              </b-col>
              <b-col md="2">
                <b-button
                  @click="findWalletStatementData"
                  size="sm"
                  variant="primary"
                  class="my-2 mr-2 my-sm-0"
                  >Find</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <b-card class="card-wrap" border-variant="info">
        <div>
          <b-table
            :dark="false"
            :hover="true"
            :striped="false"
            :bordered="true"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="walletList"
            :fields="walletColumns"
            :current-page="currentPage"
            :per-page="perPage"
            thead-class="header"
            show-empty
          >
            <template slot="amount" slot-scope="data">
              <p v-if="data.item.amount > 0">{{ data.item.amount }}</p>
              <p v-if="data.item.amount < 0">{{ Math.abs(data.item.amount) }}</p>
            </template>
            <template slot="action" slot-scope="data">
              <p v-if="data.item.amount > 0">
                <v-avatar size="23">
                  <img class="mr-1" src="img/Credit.png" alt="" />
                </v-avatar>
                Credited
              </p>
              <p v-if="data.item.amount < 0">
                <v-avatar size="23">
                  <img src="img/Debit.png" alt="" />
                </v-avatar>
                Debited
              </p>
            </template>
            <template slot="empty">
              <div v-if="isloading" class="text-center">
                <span><b>Loading...</b></span>
              </div>
              <div v-else class="text-center">No data available.</div>
            </template>
          </b-table>
        </div>
        <div style="float: right">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="walletList.length"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentHeader";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";
export default {
  name: "WalletStatement",
  components: {
    ebButton,
    ComponentHeader,
    loader,
  },
  data() {
    return {
      walletStartDate: "",
      walletEndDate: "",
      isloading: false,
      currentPage: 1,
      perPage: 10,
      walletColumns: [
        {
          key: "id",
        },
        {
          key: "amount",
        },
        {
          key: "date",
        },
        {
          key: "description",
        },
        {
          key: "action",
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      partnerAllData: "partner/GetPartnerData",
      getWalletList: "walletstatement/GetWalletList",
      getWalletBalance: "walletstatement/GetWalletBalanceAll",
    }),
    orgoName() {
      try {
        if (this.partnerAllData.organization && this.partnerAllData.organization.name) {
          return this.partnerAllData.organization.name;
        } else {
          return "Not Avilable";
        }
      } catch (err) {
        return "Not Avilable";
      }
    },
    walletBalence() {
      try {
        if (this.getWalletBalance.balanceData) {
          return this.getWalletBalance.balanceData.map((x) => x.balance) || 0;
        } else {
          return "Not Available";
        }
      } catch (err) {}
    },
    walletList() {
      try {
        let data = this.getWalletList;
        let walletTableList = [];
        if (Array.isArray(data) && data.length > 0) {
          data.map((obj) => {
            let arrObj = {
              id: obj.transactionRef,
              date: this.getProperDate(obj.createdAt),
              description: obj.description,
              action: obj.action,
              ...obj,
            };
            walletTableList.push(arrObj);
          });
          return walletTableList;
        } else {
          return walletTableList;
        }
      } catch (err) {
        return [];
      }
    },
  },
  methods: {
    ...mapActions({
      fetchWalletBalance: "walletstatement/fetchWalletBalance",
      partnerWalletData: "walletstatement/fetchWalletListAll",
    }),
    getProperDate1(data) {
      if (data != null) {
        let date = new Date(data);
        return moment(String(date)).format("YYYY-MM-DD");
      } else return "Unavailable";
    },
    getProperDate(data) {
      if (data != null) {
        let date = new Date(data);
        return moment(String(date)).format("DD/MM/YYYY");
      } else {
        return "Unavailable";
      }
    },
    async getPartnerWalletListData() {
      this.isloading = true;
      let payload = {
        from: this.getProperDate1(moment().add(-8, "days").toDate().toISOString()),
        to: this.getProperDate1(
          moment()
            .add(+1, "days")
            .toDate()
            .toISOString()
        ),
        limit: 20,
        page: 1,
        data: {
          id: this.partnerAllData._id,
        },
      };
      if (this.walletStartDate && this.walletEndDate) {
        payload.from = this.walletStartDate;
        payload.to = this.walletEndDate;
      }
      await this.partnerWalletData(payload);
      this.isloading = false;
    },
    goToViewPage() {
      this.$router.push({
        name: "PartnerView",
        params: { id: this.$route.params.id, parentId: this.$route.params.parentId },
      });
    },
    async findWalletStatementData() {
      this.isloading = true;
      await this.getPartnerWalletListData();
      this.isloading = false;
    },
    async fetchWalletBalanceData() {
      const payload = {
        amountType: "INR",
        data: {
          id: this.partnerAllData._id,
        },
      };
      await this.fetchWalletBalance(payload);
    },
  },
  async mounted() {
    this.isloading = true;
    this.fetchWalletBalanceData();
    this.getPartnerWalletListData();
    this.isloading = false;
  },
};
</script>
<style scoped>
.wallet-font {
  font-size: 17px;
}
</style>
